<div class="geoid-box">
  <label>{{label}}</label>
  <div class="address-string-wrap" *ngIf="formattedAddress">
    <span class="icon icon-map"></span>
    <span class="address-string">{{ formattedAddress }}</span>
  </div>
  <button class="bciti-inline-button" (click)="openDialog()">{{ 'common.geoid.button' | translate }}</button>
</div>
